export default __webpack_public_path__ + "static/media/ca_3.34dc4008.png";